import React from 'react'
import { pcl5_questions } from '../../../../escalas/pcl5/pcl5.catalog'


// Example of "pcl_5": {"peor_caso":"Respuesta a preg 1","tiempo":"Hace 3 años","muerte_real":true,"como_experimento":"Me paso a mi directamente","muerte_familiar":"Accidente o violencia","problemas":[0,1,2,3,4,0,1,2,3,4,0,1,2,3,4,0,1,2,3,4],"_id":"69950b51f494f51ff35f948d"}

// For responses example go to src/escalas/pcl5/pcl5.details.jsx

const responses = ["No del todo", "Un Poco", "Moderado", "Mucho", "Extremadamente"]

function getPcl5Interpretation(score) {
  if (score >= 33) return 'Puntuación sugestiva de TEPT'
  return 'Puntuación por debajo del umbral de TEPT'
}

const Row = ({ preg, res, i }) => (
  <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
    <td>{preg}</td>
    <td>{res}</td>
  </tr>
)

export default function Pcl5Results({ pcl5 }) {
  if (!pcl5) return null

  const { peor_caso, tiempo, muerte_real, como_experimento, muerte_familiar, problemas } = pcl5
  const score = problemas ? problemas.reduce((a, v) => a + v, 0) : 0

  return (
    <div>
      <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
        <td><strong>Puntuación total: {score} / 80</strong></td>
        <td><strong>{getPcl5Interpretation(score)}</strong></td>
      </tr>
      {peor_caso && <Row preg="Brevemente identifique el peor de los casos" res={peor_caso} i={0} />}
      {tiempo && <Row preg="¿Hace cuanto tiempo pasó?" res={tiempo} i={1} />}
      {muerte_real !== undefined && <Row preg="¿Hubo muerte real o amenaza, lesiones graves o violencia sexual?" res={muerte_real ? "Si" : "No"} i={2} />}
      {como_experimento && <Row preg="¿Cómo lo experimentó?" res={como_experimento} i={3} />}
      {muerte_familiar && <Row preg="Si el evento involucra la muerte de un familiar cercano o un amigo cercano, ¿fue debido a algún tipo de accidente o violencia, o fue por causas naturales?" res={muerte_familiar} i={4} />}
      {problemas && pcl5_questions.map((pr, i) => (
        <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
          <td>{pr}</td>
          <td>{responses[problemas[i]]}</td>
        </tr>
      ))}

      {/* {score >= 33 && <div style={{ marginTop: 10, padding: 10, backgroundColor: '#ffcccc', borderRadius: 6 }}>
        <strong>Interpretación:</strong> La puntuación sugiere la presencia de síntomas relacionados con el Trastorno de Estrés Postraumático (TEPT). Se recomienda una evaluación clínica más detallada para confirmar el diagnóstico y determinar el tratamiento adecuado.
      </div>} */}

 
    </div>
  )
}
